@let summary = $summary();
@if (summary.headline || summary.rows.length > 0) {
  <div class="tool-result-summary">
    @if (summary.headline) {
      <div class="trs-message">{{ summary.headline }}</div>
    }
    @for (row of summary.rows; track row.label) {
      <div class="trs-row">
        <span class="trs-key">{{ row.label }}</span>
        <span class="trs-value">{{ row.value }}</span>
      </div>
    }
  </div>
}
